import api from '../../services/api';
import BaseService from '../BaseService';

/** Regras de anonimização, na ordem de exibição. Campo na API: `anonimizar_<regra>_dias`. */
export const REGRAS_ANONIMIZACAO = ['sem_optin', 'cancelado', 'finalizado'];

/** Limites do número de dias aceitos pelo backend. */
export const DIAS_ANONIMIZACAO = { min: 30, max: 36500 };

/** Grupos que podem ser ocultados, na ordem do backend. `historico` não é dado do paciente: são as respostas das etapas de outros responsáveis. */
export const GRUPOS_VISIBILIDADE = ['termo', 'contato', 'nome', 'cpf', 'endereco', 'historico'];

/** Espelho de `PROFISSIONAIS_CATEGORIAS` do backend. */
export const CATEGORIAS_PRESTADOR = [
    'medicos',
    'multiprofissionais',
    'assessor_tecnico',
    'farmacias',
    'hospitais',
    'clinicas',
    'plataformas',
    'servicos_diagnostico',
    'laboratorio_diagnostico',
    'motoristas',
    'outros',
    'cooperativas_saude',
    'logistica',
];

class PrivacidadeService extends BaseService {
    constructor() {
        super('programas');
    }

    /**
     * Configuração de privacidade do programa (regras de anonimização e visibilidade).
     * @param {number} programaId
     */
    get(programaId) {
        return api.get(`${this.resource}${programaId}/privacidade/`);
    }

    /**
     * Atualiza a configuração de privacidade (aceita envio parcial).
     * @param {number} programaId
     * @param {Object} data
     */
    update(programaId, data) {
        return api.put(`${this.resource}${programaId}/privacidade/`, data);
    }

    /**
     * Dados básicos do programa (usado para exibir o nome a partir do id).
     * @param {number} programaId
     */
    getPrograma(programaId) {
        return api.get(`${this.resource}${programaId}/`);
    }
}

const privacidadeService = new PrivacidadeService();
export default privacidadeService;
